import React from "react";
import { Icon } from "../../Component";

const FormTimePickerHours = ({ selected, onChange, placeholderText, removeIcon, disabled }) => {
  const hours = Array.from({ length: 24 }, (_, i) => i + 1);

  const handleChange = (event) => {
    onChange(event.target.value);
  };

  return (
    <div className="form-control-wrap h-50">
      <div className="input-group">
        <div className={`input-group-prepend w-100`}>
          {!removeIcon && <Icon className="input-group-text" name="clock" />}
          <select
            value={selected || ""}
            onChange={handleChange}
            disabled={disabled}
            className={`form-control rounded-0 ${removeIcon ? " rounded-1" : "border-start-0 rounded-end"}`}
          >
            <option value="" disabled hidden>
              {placeholderText || "Select Hour"}
            </option>
            {hours.map((hour) => (
              <option key={hour} value={hour}>
                {hour < 10 ? `0${hour}` : hour}
              </option>
            ))}
          </select>
        </div>
      </div>
    </div>
  );
};

export default FormTimePickerHours;
